// extracted by mini-css-extract-plugin
export var logo = "styles-module--logo--83ab6";
export var richTextContentBox = "styles-module--richTextContentBox--b7078";